import clubRequest, { clubApi } from "../axios";

export type DashboardDateRange = {
  fromDate?: string;
  toDate?: string;
  inactiveDays?: number;
  lapsedDays?: number;
  topCount?: number;
};

export type MoneyMetric = {
  value: number;
  paid: number;
  pending: number;
  previousValue: number;
  changePercent: number | null;
  from?: string;
  to?: string;
};

export type DashboardOverview = {
  period: {
    from: string;
    to: string;
    days: number;
    inactiveDays: number;
    lapsedDays: number;
  };
  headline: {
    todaySales: MoneyMetric;
    monthSales: MoneyMetric;
    todayAppointments: {
      total: number;
      completed: number;
      remaining: number;
      previousTotal: number;
      changePercent: number | null;
    };
    newCustomers: { value: number; previousValue: number; changePercent: number | null };
    returningCustomers: {
      value: number;
      previousValue: number;
      changePercent: number | null;
      shareOfAllCustomersPercent: number;
    };
    capacity: {
      fillRatePercent: number;
      freeRatePercent: number;
      bookedMinutes: number;
      availableMinutes: number;
      hasSchedule: boolean;
    };
  };
  opportunities: {
    unpaidBookings: { customers: number; bookings: number; amount: number };
    tomorrowFreeCapacity: {
      freeMinutes: number;
      freeHours: number;
      availableMinutes: number;
      bookedMinutes: number;
      hasSchedule: boolean;
    };
    lapsedCustomers: { days: number; count: number };
  };
  appointmentBreakdown: {
    total: number;
    completed: number;
    upcoming: number;
    canceled: number;
    noShow: number;
    failed: number;
  };
  customerBreakdown: { total: number; new: number; returning: number; inactive: number };
  paymentSummary: {
    depositsCollected: number;
    paidBookings: { count: number; amount: number };
    unpaidBookings: { count: number; amount: number };
    totalRegisteredSales: number;
    paidSales: number;
    pendingSales: number;
  };
  salesTrend: { date: string; total: number; paid: number; pending: number }[];
  topServices: { merchantServiceId: number; title: string; count: number; sales: number }[];
  teamPerformance: {
    merchantUserId: number;
    fullName: string;
    jobTitle: string;
    image: { savedPath?: string | null } | null;
    completedAppointments: number;
    sales: number;
  }[];
};

const dashboardCountInfo = async () =>
  (await clubRequest.merchantCustomersCountList()).data;

const walletMessageCountInfo = async () =>
  (await clubRequest.balanceList()).data;

const getOverview = async (query: DashboardDateRange = {}) =>
  (
    await clubApi.request<DashboardOverview>({
      path: "/api/MerchantDashboard/Overview",
      method: "GET",
      query,
      format: "json",
    })
  ).data;

const dashboardService = {
  dashboardCountInfo,
  walletMessageCountInfo,
  getOverview,
};

export default dashboardService;
